import React from "react"

import Board_Manager from "../../../../../../gd-modules/tasks-view/board/managers/manager"
import FieldProto from "../../../../../proto/field-proto"
import Board_AggregateShell from "../../../../../../gd-modules/tasks-view/board/components/aggregate/aggregate-shell"

type Props = {
    className       : string

    manager         : Board_Manager
    field           : FieldProto

    calculatedData  : {
        own             : {value: number}
        children        : {value: number}
        total           : {value: number}

        hasOwnValue     : boolean
        hasChildren     : boolean
    }
}

// const debug = "FieldCurrency_BoardAggregate"
const debug = false

export default function FieldCurrency_BoardAggregate(props: Props) {

    let value = props.calculatedData?.total.value
    const isValid = !_.isNil(value) && !_.isNaN(value)

    debug && console.log(debug, 'render', value)

    let decimalPlaces = 2
    let currencyMark
    let normalized
    let valueLabel

    if (isValid) {
        // Round the value for display, applying decimal places
        value = gd.utils.roundToDecimals(value, decimalPlaces)

        // Ensure value is in number type for formatting and fallback to parseFloat for strings
        normalized = typeof value === 'number' ? value : parseFloat(value)

        if (!!normalized) {
            // If the column is a custom field, use its decimal places/currency symbol
            if (props.field.isCustom) {
                decimalPlaces = props.field.decimalPlaces || 0

                const currencyId = props.field.symbolId
                currencyMark = currencyId && gd.const.currency[currencyId] ? gd.const.currency[currencyId].symbol : null
            }

            // If custom field currency not set, use company default
            if (!currencyMark) {
                currencyMark = gd.const.currency[gd.company.financeCurrency].symbol
            }

            // Format the value for display: thousands grouped, fixed decimals
            valueLabel = normalized.toLocaleString(
                'en',
                {
                    useGrouping             : true,
                    minimumFractionDigits   : decimalPlaces,
                    maximumFractionDigits   : decimalPlaces
                }
            )
        }
    }

    const showLabel = isValid && !!value
    const classes = Classes("flex-no-shrink", props.className, {
        'show-on-hover': !showLabel
    })

    return (
        <Board_AggregateShell
            className   = {classes}
            manager     = {props.manager}
            hint        = {currencyMark + ' ' + valueLabel}
        >
            <div className="flex-row-left-center">
                <div className={Classes("ui5-ico-12 m-r-5 m-t-1", props.field.icon)}/>
                <div className="ui5-txt-not-important-small">
                    {currencyMark} {valueLabel}
                </div>
            </div>
        </Board_AggregateShell>
    )
}
